// extracted by mini-css-extract-plugin
module.exports = {"cover-letters-wrapper":"CoverLetterList_cover-letters-wrapper__p2nex","no-coverletter":"CoverLetterList_no-coverletter__uaUKO"};